import { environment } from '~app/environment';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';
import { GrowthBook } from '@growthbook/growthbook-react';

export const growthbookInstance = new GrowthBook({
  apiHost: environment.GROWTHBOOK_API_HOST,
  clientKey: environment.GROWTHBOOK_CLIENT_KEY,
  enableDevMode: environment.ENV !== 'prod',
});

growthbookInstance.init({
  // Optional, enable streaming updates
  streaming: true,
});

growthbookInstance.setAttributes({
  wuid: findOrCreateWuid(),
});
